import axios from "axios";
import { ExecutionRiskApiUrl } from "./ExecutionRiskApiUrl";

const executionRiskApi = axios.create({
  baseURL: ExecutionRiskApiUrl.baseUrl,
  headers: { "Content-Type": "application/json" },
});

const unwrap = (response) => {
  const body = response?.data;

  if (body?.status === false) {
    throw new Error(body.message || "Execution risk operation failed");
  }

  if (body && Object.prototype.hasOwnProperty.call(body, "data")) {
    return body.data;
  }

  return body ?? null;
};

export const createExecutionRisk = async (payload) =>
  unwrap(await executionRiskApi.post(ExecutionRiskApiUrl.create, payload));

const extractExecutionRiskList = (result) => {
  const candidates = [
    result,
    result?.data,
    result?.content,
    result?.records,
    result?.result,
    result?.responseData,
    result?.executionRisks,
    result?.executionRiskList,
    result?.response,
    result?.response?.data,
    result?.response?.content,
  ];
  const list = candidates.find(Array.isArray);

  if (list) return list;
  if (
    result &&
    typeof result === "object" &&
    (result.id != null || result._id != null || result.userId != null || result.tradingMode != null)
  ) {
    return [result];
  }

  return [];
};

export const getAllExecutionRisk = async () => {
  const result = unwrap(await executionRiskApi.get(ExecutionRiskApiUrl.getAll));
  const executionRiskList = extractExecutionRiskList(result);
  console.log("Execution risk Get All response:", result);
  console.log("Execution risk normalized records:", executionRiskList);
  return executionRiskList;
};

export const getExecutionRiskById = async (id, userId) =>
  unwrap(
    await executionRiskApi.get(ExecutionRiskApiUrl.getByIdAndUser, {
      params: { id, userId },
    })
  );

export const updateExecutionRisk = async (id, userId, payload) =>
  unwrap(
    await executionRiskApi.put(ExecutionRiskApiUrl.update, payload, {
      params: { id, userId },
    })
  );

export const deleteExecutionRisk = async (id, userId) =>
  unwrap(
    await executionRiskApi.delete(ExecutionRiskApiUrl.delete, {
      params: { id, userId },
    })
  );

export const getExecutionRiskId = (executionRisk) =>
  executionRisk?.id ?? executionRisk?._id ?? executionRisk?.executionRiskId ?? null;
